import React from 'react';
import { useTranslation } from 'react-i18next';

interface QuestionCardProps {
  question: string;
  currentQuestionIndex: number;
  totalQuestions: number;
  onYes: () => void;
  onNo: () => void;
}

const QuestionCard: React.FC<QuestionCardProps> = ({ 
  question, 
  currentQuestionIndex, 
  totalQuestions, 
  onYes, 
  onNo 
}) => {
  const { t } = useTranslation();

  return (
    <div className="animate-scale-up">
      <div className="bg-white rounded-2xl p-6 card-shadow">
        <div className="mb-4 flex justify-between items-center">
          <span className="text-sm font-medium text-gray-500">
            {t('question')} {currentQuestionIndex + 1} {t('of')} {totalQuestions}
          </span>
          <div className="w-24 h-2 bg-gray-100 rounded-full overflow-hidden">
            <div 
              className="h-full bg-sangre-500 transition-all duration-500 ease-out"
              style={{ width: `${((currentQuestionIndex + 1) / totalQuestions) * 100}%` }}
            ></div>
          </div>
        </div>
        
        <h3 className="text-xl font-medium text-gray-800 mb-6">{question}</h3>
        
        <div className="flex space-x-4">
          <button 
            onClick={onNo}
            className="flex-1 py-3 px-6 rounded-xl bg-gray-100 text-gray-800 font-medium hover:bg-gray-200 transition-colors duration-300 active:scale-95"
          >
            {t('no')}
          </button>
          <button 
            onClick={onYes}
            className="flex-1 py-3 px-6 rounded-xl bg-sangre-500 text-white font-medium hover:bg-sangre-600 transition-colors duration-300 active:scale-95"
          >
            {t('yes')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionCard;
